import React, { useEffect } from 'react';
import classes from './styles.module.scss';
import LeftMenu from './components/menu.component';
import { Outlet, useParams } from 'react-router-dom';
import Header from './components/header.component';
import { useKato } from '../../contexts/kato.context';
import { useShared } from '../../contexts/shared.context';
const AdminPage = () => {
  const { updatedGeneralInfo } = useKato();
  const { kato } = useParams<{ kato: string }>();
  const { selectedInfoYear } = useShared();

  useEffect(() => {
    updatedGeneralInfo(selectedInfoYear);
  }, [kato, selectedInfoYear]);

  return (
    <div className={classes.admin}>
      <LeftMenu />
      <div className={classes.admin__body}>
        <Header />
        <div className={classes.admin__content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
